import { animate, useInView, useMotionValue, useTransform } from 'framer-motion';
import { useEffect, useRef, useState } from 'react';

import { EASE_OUT } from '../constants';

export function AnimatedCounter({ target, suffix = '', prefix = '', duration = 2 }: { target: number; suffix?: string; prefix?: string; duration?: number }) {
  const ref = useRef<HTMLSpanElement>(null);
  const isInView = useInView(ref, { once: true, margin: '-60px' });
  const count = useMotionValue(0);
  const rounded = useTransform(count, (v) => Math.round(v));
  const [display, setDisplay] = useState(0);

  useEffect(() => {
    const unsub = rounded.on('change', (v) => setDisplay(v));
    return unsub;
  }, [rounded]);

  useEffect(() => {
    if (!isInView) return undefined;
    const controls = animate(count, target, { duration, ease: EASE_OUT });
    return controls.stop;
  }, [isInView, count, target, duration]);

  return (
    <span ref={ref} className='font-mono tabular-nums'>
      {prefix}
      {display.toLocaleString()}
      {suffix}
    </span>
  );
}
